/**
 * widgets/registry.acm-self.tsx — Veřejný přístup k ACM control-plane (2.1).
 * Jen služby ACM (UI/API/MCP/Agent), ne workload appky.
 */
import { Bot, Globe, Key, KeyRound, Server } from 'lucide-react';
import type { WidgetSpec } from './types';
import {
  AclPanel,
  DomainsPanel,
  SecurityPanel,
  ServicesPanel,
} from '../pages/modules/acm-self/panels';
import { CodableAccessCard } from '../components/CodableAccessCard';
import { NodeDirectoryPanel } from '../components/NodeDirectoryPanel';
import { NODE_DIRECTORY_WIDGET_ID } from '../lib/node-directory';

export const ACM_SELF_WIDGETS: WidgetSpec[] = [
  {
    // Adresář VŠECH ACM uzlů s odkazem na dashboard / MCP — i uzly mimo mesh
    // (zákaznické, jiný cluster). Jen platform admin; na dashboard se adminovi
    // jednou sám vloží (seedWidgetOnce), pak si ho může přesunout/odebrat.
    id: NODE_DIRECTORY_WIDGET_ID,
    title: 'ACM nodes',
    module: 'acm-self',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Server,
    scopes: ['acm:admin'],
    since: '2.2.1',
    component: NodeDirectoryPanel,
  },
  {
    // CodAble má vlastní UI a MCP URL — patří do Veřejného přístupu vedle
    // služeb ACM. Když ho uzel nemá, karta nabídne nasazení (Filip 2026-08-17).
    id: 'acm-self.codable-access',
    title: 'CodAble public access',
    module: 'acm-self',
    kind: 'custom',
    format: 'md',
    formats: ['md', 'lg'],
    icon: Bot,
    since: '2.2.0',
    component: CodableAccessCard,
  },
  {
    id: 'acm-self.services',
    title: 'ACM public services',
    module: 'acm-self',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Globe,
    since: '2.1.0',
    component: ServicesPanel,
  },
  {
    id: 'acm-self.acl',
    title: 'ACM admin ACL',
    module: 'acm-self',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: KeyRound,
    since: '2.1.0',
    component: AclPanel,
  },
  {
    id: 'acm-self.domains',
    title: 'Platform domains',
    module: 'acm-self',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Globe,
    since: '2.1.0',
    component: DomainsPanel,
  },
  {
    id: 'acm-self.security',
    title: 'Master key',
    module: 'acm-self',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Key,
    since: '2.1.0',
    component: SecurityPanel,
  },
];
